/**
 * Created by dri on 12/7/17.
 */
import {SensorConfigCollection} from "../../../collections/SensorConfigs";
import * as _ from "lodash";
import * as $ from "jquery";
import * as Backbone from "backbone";
import {Module, SensorRecord} from "../../../models/Module";
import {PermissionCollection} from "../../../collections/Permissions";
import {ActionPacketCollection} from "../../../collections/ActionPackets";
import {SensorConfig} from "../../../models/SensorConfig";

var buffer = require('buffer');

var template = require('templates/settings/sensor_config/modbusWrite.html');
var modbusBlockTemplate = require('templates/settings/sensor_config/modbusWriteBlock.html');
modbusBlockTemplate = _.template(modbusBlockTemplate);

export interface BaseControlViewOptions extends Backbone.ViewOptions<Backbone.Model> {
    actionPackets: ActionPacketCollection,
    permissionCollection: PermissionCollection,
    currentInstallId: number,
    con: SensorRecord,
    module: Module,
    sensorId: number,
    config: Backbone.Collection<SensorConfig>
}

export class ModbusWriteView extends  Backbone.View<Backbone.Model>  {

    template = _.template(template);

    sensorConfigCollection: SensorConfigCollection;
    config: SensorConfigCollection;
    collectionLoaded: boolean = false;

    permissionCollection: PermissionCollection;
    currentInstallId: number;
    sensorId: number;
    con: SensorRecord;
    module: Module;
    actionPackets: ActionPacketCollection;

    constructor(options: BaseControlViewOptions) {
        super(<any> _.extend(options, {
            events: {
                'click .settings-controls-modbus-add-block': 'handleAddButtonClick',
                'click .settings-controls-modbus-trash': 'handleTrashClicked',
                'click #settings-sensorconfig-save-button': 'handleSaveButtonClick'
            }
        }));
        this.permissionCollection = options.permissionCollection;
        this.currentInstallId = options.currentInstallId;
        this.con = options.con;
        this.module = options.module;
        this.sensorId = options.sensorId;
        this.actionPackets = options.actionPackets;

        this.sensorConfigCollection = new SensorConfigCollection([], {moduleId: this.module.get('module_id')});

        $.when(this.sensorConfigCollection.fetch()).done(() => {
            this.collectionLoaded = true;
            this.config = new SensorConfigCollection(this.sensorConfigCollection.where({
                sensor_id: this.sensorId,
            }), {moduleId: this.module.get('module_id')});

            this.render();
        });
    }

    render() {
        this.$el.html(this.template({
            permissionCollection: this.permissionCollection,
            installId: this.currentInstallId,
            con: this.con,
            module: this.module,
            collectionLoaded: this.collectionLoaded
        }));

        if(this.collectionLoaded){
            this.addEmptyBlock();
        }
        return this;
    }

    addEmptyBlock() {
        this.$('.settings-controls-modbus-blocks').append(modbusBlockTemplate());
    }

    validate() {
        var errors = [];
        var blocks = this.getBlocksFromUI();

        if(blocks.length){
            if(isNaN(blocks[0].addr) || blocks[0].addr < 1 || blocks[0].addr > 255){
                errors.push('Address must be between 1 and 255');
            }
        }
        _.each(blocks, function(block){
            if(isNaN(block.register) || block.register < 0 || block.register > (1<<14)){
                errors.push('Register must be between 0 and ' + (1<<14));
            }

            if(block.rawValue.length === 0){
                errors.push('Value cannot be empty');
            }

            var val = block.value;
            switch (block.dataType){
                case 1:
                    // 16bit uint
                    // 65535 = (1<<16)-1
                    if (val < 0 || val > 65535){
                        errors.push('The value for a unsigned 16bit integer must be between 0 and 65,535');
                    }
                    break;
                case 2:
                    // 16bit signed int
                    // -32,768 = 0 - (1<<16)/2
                    // 32,767 = ((1<<16)/2) - 1
                    if (val < -32768 || val > 32767){
                        errors.push('The value for a signed 16bit integer must be between -32,768 and 32,767');
                    }
                    break;
                case 3:
                    // 32bit uint
                    // 4294967296 = 2^32-1
                    if (val < 0 || val > 4294967295){
                        errors.push('The value for a unsigned 32bit integer must be between 0 and 4,294,967,295');
                    }
                    break;
                case 4:
                    // 32bit signed int
                    // -2147483648 = 0 - (2^32)/2
                    // 2147483647 = ((2^32)/2)-1
                    if (val < -2147483648 || val > 2147483647){
                        errors.push('The value for a signed 32bit integer must be between -2,147,483,648 and 2,147,483,647');
                    }
                    break
            }
        });

        console.log('Validate', errors, blocks);
        return !errors.length;
    }

    getControlConfig() {
        return [];
    }

    getActionPackets() {
        var blocks = this.getBlocksFromUI();
        if(!_.size(blocks)) return [];

        var fields = [{
            name: 'DELAY',
            value: this.config.findWhere({type: 'DELAY'}).get('value')
        },{
            name: 'PARITY',
            value: this.config.findWhere({type: 'PARITY'}).get('value')
        },{
            name: 'UNIFORM',
            value: this.config.findWhere({type: 'UNIFORM'}).get('value')
        },{
            name: 'ENDIAN_SWAP',
            value: this.config.findWhere({type: 'ENDIAN_SWAP'}).get('value')
        },{
            name: 'BAUD_RATE',
            value: this.config.findWhere({type: 'BAUD_RATE'}).get('value')
        }];

        var pktIndex = 0;
        _.each(blocks, function(block){
            pktIndex++;

            var reg = block.register;
            // If it's a 32 bit register set the second bit
            if(block.dataType >= 3)  reg = reg | (1 << 14);

            var buf = new buffer.Buffer(4);
            buf.fill(0);

            switch (block.dataType){
                case 1:
                    buf.writeUInt16BE(block.value);
                    break;
                case 2:
                    buf.writeInt16BE(block.value);
                    break;
                case 3:
                    buf.writeUInt32BE(block.value);
                    break;
                case 4:
                    buf.writeInt32BE(block.value);
                    break;
                case 5:
                    buf.writeFloatBE(block.value, 0);
                    break;
            }

            fields.push({
                name: 'ADDR' + pktIndex,
                value: block.addr
            },{
                name: 'FUNC' + pktIndex,
                value: block.func
            },{
                name: 'REG' + pktIndex,
                value: reg
            },{
                name: 'DATA' + pktIndex,
                value: buf.readUInt16BE(0)
            });

            if(block.dataType >= 3){
                pktIndex++;

                fields.push({
                    name: 'ADDR' + pktIndex,
                    value: block.addr
                },{
                    name: 'FUNC' + pktIndex,
                    value: block.func
                },{
                    name: 'REG' + pktIndex,
                    value: reg
                },{
                    name: 'DATA' + pktIndex,
                    value: buf.readUInt16BE(2)
                });
            }
        });

        fields.push({
            name: 'NB32',
            value: pktIndex
        });

        var sensorActionPacket = this.actionPackets.findWhere({
            sensor_id: this.sensorId,
            name: 'ModbusWrite'
        });
        console.log('sap', sensorActionPacket);
        var partial = _.find(sensorActionPacket.get('partials'), {name: 'ModbusWrite'});

        var time = (new Date()).getTime();
        return [{
            fields: fields,
            partialId: (<any> partial).id,
            createdSeconds: Math.floor(time / 1000),
            validSeconds: 3600,
            uniqueName: 'ModbusWrite-' + time
        }];
    }

    getBlocksFromUI() {
        var blocks = [];
        var addr = this.$('.settings-controls-modbus-address').val();
        this.$('.settings-controls-modbus-block').each(function(){
            var block = $(this);

            var func = (<string> block.find('.settings-controls-modbus-function').val());
            var dataType = (<string> block.find('.settings-controls-modbus-data-type').val());
            var register = (<string> block.find('.settings-controls-modbus-register').val());
            var value = (<string> block.find('.settings-controls-modbus-value').val());

            if(!register.length) return;

            blocks.push({
                addr: Number(addr),
                rawAddr: addr,
                func: Number(func),
                dataType: Number(dataType),
                register: Number(register),
                rawRegister: register,
                value: Number(value),
                rawValue: value
            });
        });

        return blocks;
    }

    handleTrashClicked(e: JQuery.UIEventBase) {
        $(e.currentTarget).parents('.settings-controls-modbus-block').remove();
    }

    handleAddButtonClick() {
        this.addEmptyBlock();
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/settings/sensor_config/ModbusWriteView.ts